import filterCompute from '../computed/filterCompute'

const hasFilteredOptions = ({ resolve, props, path }) => {
  const filteredOptions = resolve.value(filterCompute(props.namespace))
  if (filteredOptions.length > 0) {
    return path.true({ filteredOptions })
  } else {
    return path.false()
  }
}

hasFilteredOptions.displayName = 'hasFilteredOptions'
export default hasFilteredOptions
